<script lang="ts">
	import { analytics } from '$lib/analytics';
	import type { UploadedImage } from '$lib/diffusionApi';
	import { onMount } from 'svelte';

	export let uploadedImages: UploadedImage[];
	export let htmlUploadedImages: HTMLImageElement[];

	export let displayUploadedImageIndex: number | undefined;
	export let displayUploadedImage: UploadedImage | undefined;

	export let index: number;
	export let uploadedImage: UploadedImage;

	export let assetSelectionIds: string[];
	export let clickAssetAction: 'view' | 'select';

	export let showSelectionBoxes: boolean;
	export let useMasonry: boolean;

	export let openUploadedImageModal: () => void;

	let imageWidth = 'w-[11rem]';

	const handleAction = () => {
		if (clickAssetAction === 'view') {
			analytics.capture('view_uploaded_image', {
				upload_id: uploadedImage.upload_id
			});
			displayUploadedImageIndex = index;
			displayUploadedImage = uploadedImage;
			openUploadedImageModal();
		} else if (clickAssetAction === 'select') {
			if (assetSelectionIds.includes(uploadedImage.upload_id)) {
				assetSelectionIds = assetSelectionIds.filter((_) => _ !== uploadedImage.upload_id);
			} else {
				assetSelectionIds = [...assetSelectionIds, uploadedImage.upload_id];
			}
		}
	};

	onMount(() => {
		const isAboveSmall = window.matchMedia('(min-width: 640px)').matches;
		if (uploadedImages.length === 1) {
			if (isAboveSmall) {
				imageWidth = 'w-[33rem]';
			} else {
				imageWidth = 'w-[22rem]';
			}
		} else if (uploadedImages.length === 2) {
			if (isAboveSmall) {
				imageWidth = 'w-[16.5rem]';
			} else {
				imageWidth = 'w-[11rem]';
			}
		}
	});
</script>

<div
	class={`flex flex-col justify-center items-center relative group
		${useMasonry ? `${imageWidth}` : 'w-44 aspect-w-1 aspect-h-1'} overflow-hidden
    ${index === uploadedImages.length - 1 ? `load-more` : ''}`}
>
	<img
		loading="lazy"
		src={htmlUploadedImages[index].src}
		alt="Uploaded"
		class={`pointer-events-none object-cover group-hover:opacity-75 ${useMasonry ? `${imageWidth} rounded` : ''} bg-navy-900`}
	/>
	{#if useMasonry}
		<div class="h-[2px]"></div>
	{/if}
	<div
		class={`absolute w-full h-full ${assetSelectionIds.includes(uploadedImage.upload_id) ? 'bg-cyan-400 opacity-15' : ''}`}
	></div>
	<div
		role="button"
		tabindex="0"
		class={`absolute inset-0 focus:outline-none library-image-button ${assetSelectionIds.includes(uploadedImage.upload_id) ? 'shadow-[inset_0_0_0_2px_#22D3EE]' : ''}`}
		on:click={() => {
			handleAction();
		}}
		on:keydown={(e) => {
			if (e.key === 'Enter') {
				handleAction();
			}
		}}
	>
		<span class="sr-only">View details for asset.</span>
		{#if showSelectionBoxes}
			<button
				class={`absolute bottom-1 left-1 w-10 h-10 rounded bg-navy-900 text-navy-900 hover:text-zinc-800 hover:brightness-150
            ${!assetSelectionIds.includes(uploadedImage.upload_id) ? 'pin-controls border border-zinc-800' : 'border-2 border-cyan-400'}`}
				on:click={(e) => {
					e.stopPropagation();
					if (assetSelectionIds.includes(uploadedImage.upload_id)) {
						assetSelectionIds = assetSelectionIds.filter((_) => _ !== uploadedImage.upload_id);
					} else {
						assetSelectionIds = [...assetSelectionIds, uploadedImage.upload_id];
					}
				}}
			>
				{#if assetSelectionIds.includes(uploadedImage.upload_id)}
					<i class="fa-solid fa-check text-cyan-200"></i>
				{:else}
					<i class="fa-solid fa-check"></i>
				{/if}
			</button>
		{/if}
	</div>
</div>

<style>
	.pin-controls {
		visibility: hidden;
	}

	.library-image-button:hover .pin-controls,
	.pin-controls.active {
		visibility: visible;
	}
</style>
